import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Cuánto tiempo toma ver resultados?',
  answer: 'La mayoría de nuestros clientes HVAC empiezan a recibir llamadas en los primeros 7-14 días después de activar el sistema. Los resultados completos se consolidan en 30-60 días.'
}, {
  question: '¿Qué pasa si ya tengo una agencia o community manager?',
  answer: 'No hay problema. Nuestro sistema complementa o reemplaza lo que ya tienes. La diferencia es que nosotros nos enfocamos en generar llamadas y contratos, no likes o seguidores.'
}, {
  question: '¿Los leads son exclusivos para mi negocio?',
  answer: 'Sí, 100%. A diferencia de plataformas como HomeAdvisor o Angi, cada lead que generamos es exclusivamente tuyo. No compartimos con tu competencia.'
}, {
  question: '¿Cuánto cuesta el servicio?',
  answer: 'Depende de tu mercado y objetivos. Por eso ofrecemos el diagnóstico gratuito primero — para darte un plan personalizado con números reales. No hay sorpresas.'
}, {
  question: '¿Funciona en mi ciudad?',
  answer: 'Sí. Nuestro sistema funciona en cualquier mercado de Estados Unidos. De hecho, cuanto menos competencia digital haya en tu zona, mejores resultados obtendrás.'
}, {
  question: '¿Necesito un sitio web?',
  answer: 'No necesariamente. Nosotros creamos landing pages de alta conversión específicas para tu negocio. Tu sitio web actual puede seguir funcionando en paralelo.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24 bg-[#0D0D0D] border-t border-white/5" data-id="element-73">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-74">
        <div className="max-w-3xl mx-auto" data-id="element-75">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-white text-center mb-16" data-id="element-76">
            Preguntas{' '}
            <span className="text-[#FFD700] drop-shadow-[0_0_8px_rgba(255,215,0,0.3)]" data-id="element-77">
              Frecuentes
            </span>
          </motion.h2>

          <div className="space-y-4" data-id="element-78">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.08
          }} className={`border rounded-xl overflow-hidden transition-all duration-300 ${openIndex === index ? 'border-[#50C878] shadow-[0_0_15px_rgba(80,200,120,0.2)]' : 'border-white/10 hover:border-[#50C878]/50'}`} data-id="element-79">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left bg-[#0A0A0A] hover:bg-[#111111] transition-colors" data-id="element-80">
                  <span className={`text-lg font-bold pr-4 transition-colors ${openIndex === index ? 'text-[#50C878]' : 'text-white'}`} data-id="element-81">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180 text-[#50C878]' : 'text-[#C0C0C0]'}`} data-id="element-82" />
                </button>
                <AnimatePresence data-id="element-83">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden bg-[#0A0A0A]" data-id="element-84">
                      <div className="px-6 pb-6 pt-2 text-[#C0C0C0] leading-relaxed border-t border-white/5 mx-6" data-id="element-85">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}